const TCSFounder = () => {
  return (
    <div>
      <div className="bg-[#fcfcfc] pt-[2rem]">
        <div className="sm:max-w-[70rem] mx-auto sm:px-[10rem] lg:flex grid  lg:justify-between items-end">
          <div className="mb-[2.5rem] lg:grid hidden">
            <h1 className="lg:text-[30px] md:text-[30px] sm:text-[30px] text-[30px] font-bold">
              Khalid Nawaz Awan
            </h1>
            <p>Founder and Chairman</p>
          </div>
          <div className="flex justify-end mx-[2rem]">
            <img
              src="/leadershipnew/khalid-nawaz2.jpg"
              alt=""
              className="lg:h-[26rem] h-[17rem] leadership-images mx-[2rem]  leadership-images"
            />
          </div>
          <div className="mb-[2.5rem] mx-[2rem]  lg:hidden grid justify-left mt-[.7rem]">
            <h1 className="lg:text-[32px] md:text-[32px] sm:text-[32px] text-[26px] font-bold">
              Khalid Nawaz Awan
            </h1>
            <p>Founder and Chairman</p>
          </div>
        </div>
      </div>
      <div className="sm:max-w-[40rem] lg:mx-auto md:mx-[5rem] mx-[2rem] my-[4rem] flex flex-col justify-center items-center text-left gap-4">
        <p>
          A mechanical engineer by education, Mr Khalid Nawaz Awan was born in
          Dera Ismail Khan. He entered the courier and logistics business in
          1982 when his elder brother established a joint venture, DHL Pakistan
          Private Ltd. with the global giant. The two brothers then founded TCS
          Private Ltd. as the domestic arm accompanying the international
          business.
        </p>
        <p>
          The first decade saw a phenomenal growth of business. Soon it became
          obvious that the future potential of the business—domestic and
          international—required long term re-structuring. The brothers astutely
          addressed this in 1991 by diverging the organisation into two
          companies, enabling each to pursue its own trajectory independently.
        </p>
        <p>
          Khalid Nawaz Awan, who had been serving as the Managing Director of
          both the TCS and the DHL Pakistan under the Chairmanship of Sadiq
          Awan, took over as the Chairman and the Managing Director of TCS
          Private Limited. The challenges that emerged after this decision have
          been the subject of a Harvard Business School Case Study which was
          commenced in 2002. Up until 2007, when Sadiq Awan disinvested his
          share in DHL Pakistan, TCS maintained a collaborative non-competitive
          relationship with DHL. Meanwhile, Khalid Awan went on to pilot the
          evolution of TCS in Pakistan while establishing TCS foothold in the UK
          (1989), the UAE (1996), and Canada (1999). On the 30th anniversary of
          its founding in 2013, Khalid Awan outlined the course of TCS, guided
          by a mission statement, core values, and a young leadership for the
          next thirty years.
        </p>
        <p>
          Mr Awan is an active philanthropist who generously contributes to
          organisations working in the fields of health, education, and social
          welfare. He is a lifetime member of the World Presidents’ Organisation
          (WPO), and a member of the Chartered Institute of Transport, and
          Fellow of the Royal Aeronautical Society. He has served as the
          Chairman of Khalid Nawaz Awan Foundation and the Chairman TCS Holdings
          Private Limited—YPO Pakistan Chapter. He has chaired the Corporate
          Award Committee of the Management Association of Pakistan (MAP). He
          also serves on the Pakistan National Committee of the International
          Chambers of Commerce (ICC), and the Board of Governors—Karachi Council
          of Foreign Relations and Community Advisory Board of the Aga Khan
          University Hospital, Karachi. From 1997–2007, Mr Awan served on the
          Paris based Transportation Committee of the ICC, and represented it at
          the United Nations in 2003 General Assembly Session on Millennium
          Development Goals. He has also advised the Government of Pakistan on
          the development of Pakistan Postal Services.
        </p>
        {/* <p>
          It was thus in 1991 that Khalid Awan, who had served as Managing
          Director, since inception, of both TCS and DHL Pakistan under the
          Chairmanship of Sadiq Awan, took over as the Chairman and M.D. of TCS
          Private Limited.
        </p>
        <p>
          The challenges and implications of this decision are the subject of a
          Harvard Business School Case Study undertaken in 2002.
        </p>
        <p>
          Between then and 2007 when Sadiq Awan disinvested his share-holding in
          DHL Pakistan, TCS and DHL maintained a collaborative non-competitive
          relationship.
        </p>
        <p>
          Khalid Awan not only piloted the evolution of TCS in Pakistan but also
          went on to establish TCS in UK (1989), UAE (1996), and Canada (1999).
        </p>
        <p>
          On the 30th anniversary of its founding in 2013, Khalid Awan outlined
          for TCS its course for the next thirty years by installing a
          futuristic young leadership, guided by a mission statement and
          core-values in a world class corporate environment overseen by a
          competent Board.
        </p>
        <p>
          Mr. Awan is an active philanthropist who generously contributes to
          organizations in the field of health, education, and social welfare.
        </p>
        <p>
          He is a lifetime member of 'World Presidents Organization' - WPO, and
          has served as Chairman of Khalid Nawaz Awan Foundation and Chairman
          TCS Holdings Private Limited YPO Pakistan Chapter. He has chaired the
          'Corporate Award Committee of the Management Association of Pakistan
          (MAP) and serves on the Pakistan National Committee of the
          International Chambers of Commerce (ICC), and the Board of Governors -
          Karachi Council of Foreign Relations and Community Advisory Board of
          the Aga Khan University Hospital, Karachi.
        </p>
        <p>
          He served on the Paris based Transportation Committee of the ICC from
          1997-2007, and represented it at the United Nations 2003 General
          Assembly Session on Millennium Development Goals.
        </p>
        <p>
          He has also advised the Government of Pakistan on development of
          Pakistan Postal Services.
        </p>
        <p>
          Mr. Awan is a member of the Chartered Institute of Transport, and
          Fellow of the Royal Aeronautical Society.
        </p> */}
      </div>
    </div>
  );
};

export default TCSFounder;
